import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  BackButton,
  CustomTab,
  Loader,
  SuccessModal,
  Table,
  WarningModal,
} from "src/components";
import { strategies, strategiesSupplier } from "./constants";
import { Title, commonVaribles } from "src/constants/constVariables";
import useAuthorizationContext from "src/providers/AuthorizationHandler/useAuthorizationContext";
import {
  strategiesColumnName,
  keyOrderforpackaging_strategy,
} from "src/constants/constant";
import { downloadData, IsUserRoleMatch, UpperFirstLetter, convertISTtoUTC, uploadExcelFile } from "src/constants/utils";
import { packaging_strategy_all_endpoints, packaging_strategy_view_all_endpoints, user_management_service } from "../../constants/url";

import globalstyle from "src/assets/scss/global.module.scss";
import { colors } from "src/assets/scss/partials/colors";

import styles from "./PackagingStrategyListing.module.scss";
import { hasEditAccess } from "src/authorization/authorizationsConstants";
import { FeedbackModal } from "src/components/Modals/FeedbackModal";
import { ApprovalFormModal } from "src/components/Modals/ApprovalFormModal";
import { baseApiCall, isEmpty } from "src/api/Api";
import { store } from 'src/redux';
import { darftedData, onResponse } from 'src/redux/features';

import { BulkExcelUploadModal } from "src/components/Modals/UploadExcelModal";
import { useDispatch } from "react-redux";
import axios from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import clsx from "clsx";
import { endOfToday, startOfYesterday } from "date-fns";

export function PackagingStrategyListing() {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useAuthorizationContext();
  const [dataset, setDataset] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [daterange, setDaterange] = useState();
  const [startDate, setStartDate] = useState(convertISTtoUTC(startOfYesterday()));
  const [endDate, setEndDate] = useState(convertISTtoUTC(endOfToday()));
  const [totalData, setTotalData] = useState(0);
  const [checkedState, setCheckedState] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteData, setDeleteData] = useState([]);
  const [isWarningModalOpen, setWarningModalIsOpen] = useState(false);
  const [allSelectedRows, setAllSelectedRows] = useState(false);
  const [checkedStateAll, setCheckedStateAll] = useState(false);
  const [selectCount, setSelectCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [title, setTitle] = useState({});
  const [isModalOpen, setModalIsOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loaderTbl, setLoaderTbl] = useState(true);
  const [isImageUploadModalOpen, setImageUploadModalOpen] = useState(false);
  const [directMaterialPurchaseBuyerList, setDirectMaterialPurchaseBuyerList] = useState([]);

  const [partNo, setPartNo] = useState();
  const [statergyId, setStatergyId] = useState();
  const [selectedApprovalData, setSelectedApprovalData] = useState();
  const [isImgModalOpen, setImgModalIsOpen] = useState(false);
  const [isApprovalModalOpen, setApprovalModalIsOpen] = useState(false);

  const countRef = useRef(0);
  const [isExcelUploadModalOpen, setExcelUploadModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [excelfile, setexcelfile] = useState([]);
  const [ismodalLoader, SetModalloader] = useState(false);
  const [isReupload, SetIsReupload] = useState(false);
  const [commodityTypeList, setCommodityTypeList] = useState([]);
  const [selectedCommodityTypeData, SetSelectedCommodityData] = useState([]);
  const [selectedDirectMaterialPurchaseBuyerList, SetSelectedDirectMaterialBuyerList] = useState([]);
  const [searchMessage, setSearchMessage] = useState(commonVaribles.please_use_the_search_box)
  const [dragging, setDragging] = useState(false);
  const [allPlants, setAllPlant] = useState(false);
  const [setectedPlantName, setSetectedPlantName] = useState(
    store?.getState()?.allPlants?.plantName?.length !== 0
      ? store?.getState()?.allPlants?.plantName
      : store?.getState()?.allPlants?.plants[0]
  );
  const [failedFiles, setFailedFiles] = useState([]);
  const [plantId, setPlantId] = useState();

  const searchData = state?.search;
  const FeedbackModalViewer = ({ rowData }) => {
    const handleOpen = (e) => {
      e.preventDefault();
      setPartNo(rowData.part_no)
      setStatergyId(rowData.id)
      setPlantId(rowData.plant_id)
      setImgModalIsOpen(true);
      SetModalloader(true);
    };

    return (
      <div>
        <div>
          <div className={styles.viewButton} onClick={(e) => handleOpen(e)}>View</div>
        </div>
      </div>
    );
  };

  const ReuploadModalViewer = ({ rowData }) => {
    const handleOpen = (e) => {
      e.preventDefault();
      let tempData = directMaterialPurchaseBuyerList?.find((item => item?.value == rowData?.dmp_buyer_status_evaluated_id))
      if (tempData?.length) {
        SetSelectedDirectMaterialBuyerList(tempData[0]);
      }
      setExcelUploadModalOpen(true);
      SetIsReupload(true);
    };

    return (
      <div>
        <div>
          <div className={styles.viewButton} onClick={(e) => handleOpen(e)}>View</div>
        </div>
      </div>
    );
  };

  const ApprovalViewer = ({ rowData }) => {
    const handleOpen = (e) => {
      const selectedApprovalRowData = {
        inco_terms: rowData?.inco_terms,
        dmp_approval_status: rowData?.dmp_approval_status,
        scm_approval_status: rowData?.scm_approval_status,
        logistics_approval_status: rowData?.logistics_approval_status,
        scm_buyer_status_evaluated_id: rowData?.scm_buyer_status_evaluated_id,
        logistics_buyer_status_evaluated_id: rowData?.logistics_buyer_status_evaluated_id,
      }
      e.preventDefault();
      setPartNo(rowData.part_no);
      setStatergyId(rowData.id);
      setSelectedApprovalData(selectedApprovalRowData);
      setApprovalModalIsOpen(true);
      SetModalloader(true);
    };

    const approvalStatusFormat = (sequence) => {
      switch (sequence) {
        case (sequence = 'approved'):
          return (
            <div className={clsx(styles.bgComplete, styles.approvalStatusButton, globalstyle.status, globalstyle.complete)}> {UpperFirstLetter(sequence)} </div>
          );
        case (sequence = 'inprogress'):
          return (
            <div onClick={(e) => handleOpen(e)} className={clsx(styles.bgProgress, styles.approvalStatusButton, globalstyle.status, globalstyle.progress)}> {UpperFirstLetter(sequence)} </div>
          );
        case (sequence = 'pending'):
          return (
            <div onClick={(e) => handleOpen(e)} className={clsx(styles.bgPending, styles.approvalStatusButton, globalstyle.status, globalstyle.pending)}> {UpperFirstLetter(sequence)} </div>
          );
        case (sequence = 'rejected'):
          return (
            <div className={clsx(styles.bgPending, styles.approvalStatusButton, globalstyle.status, globalstyle.pending)}> {UpperFirstLetter(sequence)} </div>
          );
        default:
          return (
            <div className={clsx(globalstyle.status, globalstyle.invalidstatus)}> - </div>
          );
      }
    }

    return approvalStatusFormat(rowData?.approval_status)
  };

  const DraftViewer = ({ rowData }) => {
    const fetchAndDraftData = (e) => {
      e.preventDefault();
      baseApiCall({
        url: packaging_strategy_view_all_endpoints.GET_DRAFT_PACKAGING_STRATERGIES_VIEW_BY_ID,
        requestBody: {
          drafted_strategy_id: rowData?.id,
          plant_id: rowData?.plant_id,
        },
        method: commonVaribles.post,
        onSuccess: (res) => {
          if (res?.data?.result && res?.data?.result !== "") {
            const data = res?.data?.result;
            dispatch(darftedData(data));
            setLoader(true);
            navigate('/packaging-strategy/draft-strategy');
          } else {
            setLoader(true);
          }
        },
        onFailure: () => {
          setLoader(false);
          navigate("/packaging-strategy", { state: { searchData } });
        },
        errorCall: () => {
          setLoader(false);
          navigate("/packaging-strategy", { state: { searchData } });
        },
      });
    }

    const draftStatusFormat = (sequence) => {
			switch (sequence) {
				case (sequence = 'draft'):
					return (
						<div onClick={(e) => {
								fetchAndDraftData(e);
							}}
							className={clsx(
								styles.bgInvalidstatus,
								globalstyle.status,
								globalstyle.invalidstatus
							)}
						>
							{UpperFirstLetter(sequence)}
						</div>
					);
				default:
					return (
						<div className={clsx(globalstyle.status, globalstyle.invalidstatus)}> - </div>
					);
			}
		};

    return draftStatusFormat(rowData?.approval_status)
  };

  const DownloadExcelSheet = ({ rowData }) => {
    const handleDownloadExcelFile = (e) => {
      e.preventDefault();

      if (rowData?.excel_file_name) {
        setLoader(true);
        baseApiCall({
          url: packaging_strategy_all_endpoints.GET_PRESIGNED_IMAGES,
          requestBody: {
            img_type: "logistics-excel-sheet",
            file_name: rowData?.excel_file_name,
            Skipinterceptors: true,
          },
          method: commonVaribles.post,
          onSuccess: (res) => {
            if (res && res?.data && res?.data?.result && res?.data?.result !== "") {
              const imagePath = res.data.result;
              if (imagePath) {
                const xhr = new XMLHttpRequest();
                xhr.open("GET", imagePath, true);
                xhr.responseType = "blob";
                xhr.onreadystatechange = function () {
                  if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                      const blob = xhr.response;
                      const file = URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = file;
                      a.download = rowData?.excel_file_name; // Set the filename here
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                    } else {
                      // Handle error
                      console.error("Request failed with status:", xhr.status);
                    }
                    setLoader(false);
                  }
                };
                xhr.send();
              } else {
                dispatch(
                  onResponse({
                    isToaster: true,
                    severity: commonVaribles.error,
                    message: `Failed to Download Excel file`,
                  })
                );
              }
              setLoader(false);
            } else {
              dispatch(
                onResponse({
                  isToaster: true,
                  severity: commonVaribles.error,
                  message: `Failed to Download Excel file`,
                })
              );
              setLoader(false);
            }
          },
          onFailure: () => {
            setLoader(false);
          },
          errorCall: () => {
            setLoader(false);
          },
        });
      } else {
        dispatch(
          onResponse({
            isToaster: true,
            severity: commonVaribles.error,
            message: `Excel File Not Present`,
          })
        );
      }
    };

    return (
      <div>
        <div>
          <div className={styles.viewButton} onClick={(e) => handleDownloadExcelFile(e)}>Download</div>
        </div>
      </div>
    );
  };

  // const NavigationToViewDiv = ({ rowData },event) => {
  //   const toNavigateToView = (item) => {
  //     navigate("/packaging-strategy-details", { state: { item , searchQuery } });
  //   };
  //   return (
  //     <div onClick={() => toNavigateToView(rowData)}>{rowData.part_no}</div>
  //   );
  // };

  // const toNavigateToView = (item) => {
  //   navigate("/packaging-strategy-details", { 
  //     state: { 
  //       item: JSON.parse(JSON.stringify(item)),
  //       searchQuery: JSON.parse(JSON.stringify(searchQuery)) 
  //     } 
  //   });
  // };

  useEffect(() => {
    setSearchQuery(searchQuery ? searchQuery : state?.search ? state.search : '')
    setSelectedRows(new Array(dataset.length).fill(false));
    setCheckedState(new Array(dataset.length).fill(false));
  }, [dataset, allPlants]);

  const handleCloseImageModal = () => {
    setImgModalIsOpen(false);
  };

  const handleCloseApprovalModal = () => {
    fetchPartRows();
    setApprovalModalIsOpen(false);
  };

  const increaseOffset = useCallback(() => {
    setOffset(offset + 1);
  }, [offset]);

  const increaseRef = useCallback(() => {
    countRef.current = countRef.current + 1;
  }, [countRef]);

  const fetchPartRows = async () => {
    setLoaderTbl(true);
    // if (searchQuery !== '') {
      setLoader(true);
      baseApiCall({
        url: packaging_strategy_all_endpoints.GET_PACKAGING_STRATERGIES_LIST_BY_SEARCH,
        method: commonVaribles.post,
        requestBody: {
          start_date: startDate,
          end_date: endDate,
          search_text: searchQuery,
          is_all_plants_selected: allPlants
        },
        onSuccess: (res) => {
          const data = res?.data?.result;
          const modifiedData = data.map((item) => {
            item = item?.approval_status &&
              hasEditAccess(user, commonVaribles.add_approval)
              ? { ...item, approval_status: <ApprovalViewer rowData={item} /> }
              : {
                ...item, approval_status: item?.approval_status == 'draft' ? <DraftViewer rowData={item}/> : item?.approval_status
              };
            // item = item?.approval_status == "rejected"
            //   ? { ...item, reupload: <ReuploadModalViewer rowData={item} /> }
            //   : { ...item }
            
            item =
              item?.is_feedback
                ? { ...item, feedbacks: <FeedbackModalViewer rowData={item} /> }
                : { ...item };
            // item =
            //   item?.excel_file_name &&
            //     hasEditAccess(user, commonVaribles.download_packaging_strategy)
            //     ? { ...item, excel: <DownloadExcelSheet rowData={item} /> }
            //     : { ...item };
            return item;
          });

          setDataset(modifiedData);
          increaseRef();
          increaseOffset();
          setLoader(false);
          setLoaderTbl(false);
          setSelectedRows([
            ...selectedRows,
            ...new Array(data?.length).fill(false),
          ]);
          if (data?.length == 0) {
            setSearchMessage(commonVaribles.part_logistics_sheet_Not_received)
          }
          if (offset !== 0) {
            let temp = [...dataset];
            data?.forEach((element) => {
              temp.push(element);
            });
            setTotalData(data?.length);
          } else {
            setDataset(modifiedData);
            setTotalData(data?.length);
          }
          setSearchQuery(searchQuery);
        },
        onFailure: () => {
          setLoader(false);
          setLoaderTbl(false);
        },
        errorCall: () => {
          setLoader(false);
          setLoaderTbl(false);
        },
      });
    // }
    // else {
    //   setDataset([]);
    //   setSearchQuery('');
    //   setSearchMessage(commonVaribles.please_use_the_search_box);
    //   if (state && state.search) {
    //     state.search = '';
    //   }
    //   if (!searchQuery && !isExcelUploadModalOpen) {
    //     dispatch(
    //       onResponse({
    //         isToaster: true,
    //         severity: commonVaribles.warning,
    //         message: 'Enter Part Number/Vendor Code/Supplier Name to get Data',
    //       })
    //     );
    //   }
    // }
  };

  const toggleWarningModal = (data, e) => {
    setDeleteData(data);
    setWarningModalIsOpen(!isWarningModalOpen);
  };

  const handleMultipleDelete = async (data) => {
    // Required code -- Start
    setLoaderTbl(true);
    var deleteData = [];
    var deleteJsonpayload = {};
    data?.forEach((element) => {
      deleteData.push(element.id.toString());
    });
    deleteJsonpayload = deleteData;
    baseApiCall({
      url: packaging_strategy_all_endpoints.POST_DELETE_STRATEGY_RECORDS,
      requestBody: {
        strategy_id: deleteJsonpayload,
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        fetchPartRows();
        setCheckedStateAll(false);
        setCheckedState([]);
        setModalIsOpen(true);
        setTitle(res?.data?.message);
        setSelectedRows([
          ...selectedRows,
          ...new Array(data?.length).fill(false),
        ]);
      },
      onFailure: () => {
        setLoaderTbl(false);
      },
      errorCall: () => {
        setLoaderTbl(false);
      },
    });
    // Required code -- End
  };

  const handleCheckbox = () => {
    setCheckedStateAll((prev) => {
      return !prev;
    });
  };
  const handleSingleCheckbox = (position, e) => {
    setCheckedState((prev) => {
      let a = [];
      if (prev.length === 0) {
        dataset?.map((item, index) =>
          index === position ? a.push(true) : a.push(false)
        );
      } else {
        prev?.map((item, index) =>
          index === position ? a.push(!item) : a.push(item)
        );
      }
      return [...a];
    });
  };

  useEffect(() => {
    setCheckedState((prev) => {
      return [...new Array(dataset.length).fill(checkedStateAll)];
    });
  }, [checkedStateAll]);

  const updateSetSelectedRows = async (pos, data, ind) => {
    if (pos === commonVaribles.all) {
      let ab = [];
      setAllSelectedRows(!allSelectedRows);
      ab = dataset.map((row, index) => {
        const isSelected = !data.every((row) => row.isSelected);
        if (ind.includes(index) && isSelected) {
          return true;
        } else {
          return false;
        }
      });
      ab
        ? setSelectedRows(ab)
        : setSelectedRows([
          ...selectedRows,
          ...new Array(data?.length).fill(false),
        ]);
    } else {
      setSelectedRows((prev) => {
        let a = [];
        prev.map((item, index) =>
          index === pos ? a.push(!item) : a.push(item)
        );
        return [...a];
      });
    }
  };


  useEffect(() => {
    setSelectCount(checkedState.filter((value) => value === true).length);
  }, [checkedState]);

  const onChangeFilterResetTheCheckbox = () => {
    setSelectedRows(new Array(dataset.length).fill(false));
    setCheckedState(new Array(dataset.length).fill(false));
  };

  //function for the opening of the insertion dialog for the excel file.
  const openExcelUploadFile = () => {
    document.getElementById("input_file").value = "";
    document.getElementById("input_file").click();
  };

  const handleExcelUpload = async (e, selectedFile) => {
    const selectedFiles = dragging ? Array.from(selectedFile) : [...e.target.files];
    const maxSize = 10000000; //10MB
    let exceededFiles = [];

    if (selectedFiles?.length > 5) {
      setErrorMessage(commonVaribles.excelErrorInNumbers);
    } else {
      const validFiles = selectedFiles.filter((file) => {
        if (file.size <= maxSize) {
          return true;
        } else {
          exceededFiles.push(file);
          return false;
        }
      });

      if (exceededFiles?.length > 0) {
        exceededFiles.map((fileName) => {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.error,
              message: `${fileName.name} Size Limit Exceeds`,
            })
          )
        })
      }

      const validExcelFiles = validFiles.filter((excel) =>
        /\.(xlsx|xlsm)$/i.test(excel.name)
      );
      const invalidExcelFiles = validFiles.filter(
        (excel) => !validExcelFiles.includes(excel)
      );

      if (invalidExcelFiles?.length > 0) {
        setErrorMessage(commonVaribles.excelErrormsg);
      } else {
        setErrorMessage("");
      }
      setexcelfile(validExcelFiles);
    }

    // Do something with exceededFiles array if needed
  };


  const dateSetter = (newStartDate, newEndDate) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }
  async function dateClearFilter () {
    setStartDate('');
    setEndDate('');
    return {
      defaultStartDate: '',
      defaultEndDate: ''
    }
  }

  const fetchUserRoleWiseList = () => {
    setDirectMaterialPurchaseBuyerList([]);
    const req_user_role_names = ['Direct Material Purchase Buyer']
    baseApiCall({
      url: user_management_service.GET_USER_ROLE_DETAILS_BY_ROLE,
      requestBody: {
        plant_id: setectedPlantName?.value,
        user_role_names: req_user_role_names,
        commodity_type_id: selectedCommodityTypeData?.value,
        is_dropdown_value: true,
        Skipinterceptors: true
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res?.data && res?.data?.result && res?.data?.result !== '') {
          const data = res?.data?.result;
          setDirectMaterialPurchaseBuyerList(data?.[req_user_role_names[0]]);
        } else {
          setDirectMaterialPurchaseBuyerList([]);
        }
      },
      onFailure: () => { },
      errorCall: () => { },
    });
  };

  const fetchCommodityList = () => {
    setCommodityTypeList([]);
		baseApiCall({
			url: user_management_service.GET_COMMODITY_TYPE_ROLE_DETAILS,
			requestBody: {
				plant_id: setectedPlantName?.value,
				Skipinterceptors: true,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
        if (res && res?.data && res?.data?.result && res?.data?.result !== '') {
          const data = res?.data?.result;
          setCommodityTypeList(data);
        }
      },
			onFailure: () => {},
			errorCall: () => {},
		});
	};

  const handleUpload = async (formDetails) => {
    SetModalloader(true);
    const errorsArray = [];
    const sucessArray = [];
    if (excelfile?.length === 0) {
      return;
    }

    for (const currentFile of excelfile) {
      const formData = new FormData();
      const seletctedPlant = setectedPlantName;
      const defaultValue = store.getState().allPlants.plants;
      const plantId = seletctedPlant.value
        ? seletctedPlant.value
        : defaultValue[0]?.value;
      formData.append("excel_file", currentFile);
      formData.append("selected_plant_id", plantId);
      formData.append("user_name", user.name);
      formData.append("assigned_direct_matertial_purchase_buyer_id", formDetails?.selected_dmp_user_details?.value ? formDetails?.selected_dmp_user_details?.value : '');
      formData.append("commodity_type_id", formDetails?.selected_commodity_type_details?.value ? formDetails?.selected_commodity_type_details?.value : '');

      try {
        const response = await axios.post(
          isReupload ? packaging_strategy_all_endpoints.POST_REUPLOAD_STRATEGY_EXCEL : packaging_strategy_all_endpoints.POST_ADD_STRATEGY_EXCEL_UPLOAD,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Authorization": 'Bearer ' + store.getState().loginAuth.token
            },
          }
        );
        if (response?.data.status !== 201) {
          errorsArray.push({ FileName: currentFile.name, Message: response.data.message });
        } else {
          uploadExcelFile(response?.data?.result?.presigned_url_for_add, currentFile);
          sucessArray.push({ FileName: currentFile.name, Message: response.data.message });
        }
      } catch (error) {
        errorsArray.push({ FileName: currentFile.name, Message: error.response.data.message });
      }
    }

    if (errorsArray?.length > 0) {
      const failedFileNames = errorsArray.map(item => item.FileName).join(', ');
      setFailedFiles(errorsArray);
      showUploadToast(`${errorsArray?.length} Files Fails to Uploaded ${failedFileNames}`, 'error');
    }
    if (excelfile.length - errorsArray.length > 0) {
      const sucessFileNames = sucessArray.map(item => item.FileName).join(', ');
      showUploadToast(`Total ${excelfile.length - errorsArray.length} Files Uploaded ${sucessFileNames}`, 'success');
    }
    SetModalloader(false);
    fetchPartRows();
    if (errorsArray.length == 0) {
      setExcelUploadModalOpen(false)
      setexcelfile([])
    }
  };

  const showUploadToast = (message, type) => {
    if (type === 'error') {
      toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    } else {
      toast.success(message, {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      handleExcelUpload(e, droppedFiles)
    }
  };

  const handelAllPlantCheckbox = (allPlants) => {
    // if (!isEmpty(searchQuery)) {
      fetchPartRows();
    // }
  };

  useEffect(() => {
    handelAllPlantCheckbox(allPlants);
  }, [allPlants, startDate, endDate]);

  useEffect(() => {
    fetchUserRoleWiseList();
  }, [selectedCommodityTypeData]);

  useEffect(() => {
    fetchCommodityList();
  }, [setectedPlantName]);

  const redirectToAddStrategyForm = () => {
    navigate('/packaging-strategy/add-strategy');
  };

  return (
    <div className={styles.tablecontainer}>
      <div className={globalstyle.breadcrumb}>
        <BackButton
          basePath={Title.home}
          action={Title.packaging_strategy}
          handleClick={() => {
            navigate("/");
          }}
          browserBack={true}
        />
        <div className={styles.plantNameTitle}>
          {commonVaribles.plant_name} :{" "}
          <div className={styles.plantNameTitleSelected}>
            {" "}
            <span>&nbsp;</span> {setectedPlantName?.label || "-"}
          </div>
        </div>
      </div>
      <div>
        <CustomTab
          title={Title.packaging_strategy}
          count={dataset.length}
          isSearchBar={true}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onCheckboxChange={handelAllPlantCheckbox}
          isDatepicker={true}
          isDropdown={false}
          isSelected={false}
          isCheckbox={true}
          onChangeDatefilter={dateSetter}
          searchValueFetch={fetchPartRows}
          dateClearFilter={dateClearFilter}
          startDate={startDate}
          endDate={endDate}
          setAllPlant={setAllPlant}
          allPlants={allPlants}
          // isPlantName={true}
        />
      </div>
      <input
        multiple
        type="file"
        accept=".xlsx,.xlsm"
        id="input_file"
        onChange={(e) => handleExcelUpload(e)}
        hidden
      />
      <div className={styles.tablemain}>
        {loader ? (
          <Loader />
        ) : (
          <Table
            searchMessage={searchMessage}
            columns={
              (IsUserRoleMatch('supplier', user)
                ? [...strategiesSupplier]
                : [...strategies])
            }
            defaultColumns={
              (IsUserRoleMatch('supplier', user)
                ? [...strategiesSupplier]
                : [...strategies])
            }
            rows={dataset}
            // onRowSelect={toNavigateToView}
            searchQuery={searchQuery}
            onClickPath={"/packaging-strategy-details"}
            rowHeight={38}
            isImageUploadModalOpen={isImageUploadModalOpen}
            setImageUploadModalOpen={setExcelUploadModalOpen}
            primaryActions={[
              {
                name: commonVaribles.upload_logistics_sheet,
                backgroundColor: colors.light_green,
                actionFn: () => setExcelUploadModalOpen(true),
                onclick: () => setExcelUploadModalOpen(true),
                shouldEnable: true,
                authOperation: hasEditAccess(
                  user,
                  commonVaribles.add_packaging_strategy
                ),
              },
              {
                name: commonVaribles.add_strategy,
                actionFn: () => redirectToAddStrategyForm(),
                shouldEnable: true,
                authOperation: hasEditAccess(
                  user,
                  commonVaribles.add_packaging_strategy
                ),
              },
            ]}
            secondaryActions={[
              {
                name: commonVaribles.Delete,
                actionFn: (data, e) => toggleWarningModal(data, e),
                backgroundColor: colors.light_red,
                shouldEnable: true,
                authOperation: hasEditAccess(
                  user,
                  commonVaribles.delete_packaging_strategy
                ),
              },
              {
                name: commonVaribles.Download,
                actionFn: () => {
                  const renamedHeaders = Object.keys(dataset[0]).reduce(
                    (acc, key) => {
                      const newKey = strategiesColumnName[key] || key;
                      acc[key] = newKey;
                      return acc;
                    },
                    {}
                  );
                  downloadData(
                    selectedRows,
                    dataset,
                    commonVaribles.packaging_strategy,
                    renamedHeaders,
                    keyOrderforpackaging_strategy
                  );
                },
                backgroundColor: colors.light_green,
                shouldEnable: true,
                authOperation: commonVaribles.admin,
              },
            ]}
            setAsnCount={() => { }}
            removeRowSelection={false}
            pagination={false}
            infiniteScroll={false}
            setTotalData={setTotalData}
            handleSingleCheckbox={(e) => handleSingleCheckbox(e)}
            selectedRows={selectedRows}
            selectCount={selectCount}
            updateSetSelectedRows={updateSetSelectedRows}
            handleCheckbox={handleCheckbox}
            onChangeFilterResetTheCheckbox={() =>
              onChangeFilterResetTheCheckbox()
            }
            isDataLoading={loaderTbl}
          />
        )}
        {isWarningModalOpen && (
          <WarningModal
            open={isWarningModalOpen}
            handleClose={() => toggleWarningModal()}
            confirmDelete={() => handleMultipleDelete(deleteData)}
            customMessage={commonVaribles.customDeleteMessage}
          />
        )}
        {isModalOpen && (
          <SuccessModal
            open={isModalOpen}
            handleClose={() => setModalIsOpen(false)}
            title={title}
          />
        )}

        {isImgModalOpen && (
          <FeedbackModal
            sub_title={partNo}
            id={statergyId}
            plantId={plantId}
            Modalloader={ismodalLoader}
            open={isImgModalOpen}
            handleClose={() => handleCloseImageModal()}
          />
        )}

        {isApprovalModalOpen && (
          <ApprovalFormModal
            id={statergyId}
            plantId={plantId}
            rowData ={selectedApprovalData}
            open={isApprovalModalOpen}
            handleClose={() => handleCloseApprovalModal()}
          />
        )}

        {isExcelUploadModalOpen && (
          <BulkExcelUploadModal
            open={isExcelUploadModalOpen}
            handleClose={() => {
              setExcelUploadModalOpen(false);
              SetIsReupload(false);
              setErrorMessage("");
              setexcelfile([]);
              setFailedFiles([]);
              SetSelectedDirectMaterialBuyerList([]);
              setSetectedPlantName(store?.getState()?.allPlants?.plantName?.length !== 0
                ? store?.getState()?.allPlants?.plantName
                : store?.getState()?.allPlants?.plants[0]);
            }}
            confirmUpload={(data) => handleUpload(data)}
            openUploadFile={() => openExcelUploadFile()}
            title={commonVaribles.upload_logistics_sheet}
            errorMsg={errorMessage}
            addmore={(e) => openExcelUploadFile(e)}
            excelfiles={excelfile}
            setExcel={setexcelfile}
            Modalloader={ismodalLoader}
            handleDrop={handleDrop}
            handleDragOver={handleDragOver}
            handleDragLeave={handleDragLeave}
            handleDragEnter={handleDragEnter}
            isPlantName={true}
            setSetectedPlantName={setSetectedPlantName}
            setexcelfile={setexcelfile}
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
            failedFiles={failedFiles}
            setFailedFiles={setFailedFiles}
            directMaterialPurchaseBuyerList={directMaterialPurchaseBuyerList}
            commodityTypeList={commodityTypeList}
            SetSelectedCommodityData={SetSelectedCommodityData}
            isReupload={isReupload}
          />
        )}
      </div>
      <style jsx="true">
        {`
          a {
            text-decoration: none;
            color: inherit;
          }
        `}
      </style>
    </div>
  );
}
